<template>
  <div class="staff-list">
    <template v-if="staffList && staffList.length">
      <div class="staff-item" v-for="item in staffList" :key="item.id">
        <div class="avatar">
          <van-image round width="48" height="48" :src="guest" />
        </div>
        <div class="content" v-if="item.userInfoDTO">
          <div class="name ellipsis-1">{{item.userInfoDTO.name}}</div>
          <div class="company ellipsis-1">{{item.userInfoDTO.mobile}}</div>
          <div class="btn-area">
            <div class="btn primary" @click="onDistribute(item)">分配</div>
          </div>
        </div>
      </div>
    </template>
    <Empty v-if="staffList && !staffList.length" class="empty" />

    <Loading v-model="loading" />
  </div>
</template>

<script>
  import guest from '@/assets/guest_default.png'
  import Loading from '@/components/Loading'
  import Empty from '@/components/Empty'

  export default {
    components: {
      Loading,
      Empty
    },
    data() {
      return {
        guest,
        staffList: null,
        loading: false,
        queryParams: {}
      }
    },
    created() {
      this.init()
      this.getList()
    },
    methods: {
      init() {
        const { token, appId, exhibitionId, languageType, subjectType, terminal } = this.$route.query
        this.$store.commit('changeToken', decodeURIComponent(token))
        this.queryParams = {
          appId,
          exhibitionId,
          languageType,
          subjectType,
          terminal
        }
      },
      getList() {
        this.loading = true

        this.$http.getEmployeeList(this.queryParams).then(res => {
          if (res.code == 1000) {
            this.loading = false
            this.staffList = res.data || []
          }
        })
      },
      onDistribute(item) {
        const query = this.$route.query
        const params = {
          ...this.queryParams,
          id: query.id,
          employeeId: item.id,
        }

        this.loading = true

        this.$http.distributionEmployee(params).then(res => {
          if (res.code == 1000) {
            this.$Toast.success('分配成功')
            this.$router.back()
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .staff-list {
    width: 100%;
    min-height: 100vh;
    max-width: 750px;
    margin: 0 auto;
  }
  .staff-item {
    display: flex;
    padding: 12px 16px;
    box-sizing: border-box;
    background: #ffffff;
    margin-bottom: 8px;
  }
  .avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
  }
  .content {
    flex: 1;
    padding-left: 16px;
    overflow: hidden;
  }
  .name {
    font-weight: 400;
    font-size: 16px;
    color: #140F26;
  }
  .company {
    font-size: 14px;
    color: #6E7580;
    margin-top: 4px;
  }
  .btn-area {
    display: flex;
    flex-direction: row-reverse;
    padding-top: 12px;
    .btn {
      padding: 4px 16px;
      font-weight: 400;
      font-size: 12px;
      color: #163ccc;
      border-radius: 13px;
      border: 1px solid #163ccc;
      &.primary {
        color: #FFFFFF;
        border: none;
        background: linear-gradient(142deg, #163ccc 0%, #973eff 100%);
        margin-left: 12px;
      }
    }
  }
</style>
